import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { oskaloosaConfig } from "./data";

export default function OskaloosaPage() {
  return <CityPageTemplate config={oskaloosaConfig} />;
}